// @ts-nocheck
/* eslint-disable */
import { takeLatest, all, call, put, fork } from 'redux-saga/effects';
import * as types from 'appRedux/actions/forecast';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { UPDATE_TAB_EDITED_STATE } from 'appRedux/actions/project_budget';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';

function* getForecastDataRequest(action) {
  yield put({ type: types.FORECAST_SHOW_LOADER });
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);
  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/budget_forecast_monthly/?${query}`,

    token,
  );

  if (data) {
    yield put({ type: types.GET_FORECAST_DATA_SUCCESS, payload: data });
  }
}

function* getFilteredForecastData(action) {
  yield put({ type: types.FORECAST_SHOW_LOADER });
  const token = localStorage.getItem('token');
  const { params } = action;
  const query = getQueryParams(params);
  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/budget_forecast_monthly/?${query}`,
    token,
  );

  if (data) {
    yield put({
      type: types.GET_FILTERED_FORECAST_DATA_SUCCESS,
      payload: data,
    });
  }
}

function* postForecastData(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield all([
    payload.forecastData.length > 0 &&
      call(
        services.fetchPostApi,
        `${API_URI}/forecast_api/`,
        payload.forecastData,
        token,
      ),

    payload.claimData.length > 0 &&
      call(
        services.fetchPostApi,
        `${API_URI}/claim-forecast/`,
        payload.claimData,
        token,
      ),
  ]);

  if (data.filter(Boolean).length > 0) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: UPDATE_TAB_EDITED_STATE, payload: { tabEdited: false } });
    yield put({
      type: types.POST_FORECAST_DATA_SUCCESS,
    });

    successToast('Data was updated successfully.');
  }
}

function* getForecastRowData(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/forecast_api/${payload.forecastId}/`,
    token,
  );

  if (data) {
    yield put({
      type: types.GET_FORECAST_ROW_DATA_SUCCESS,
      payload,
      res: data,
    });
  }
}

function* deleteForecastData(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/feature_delete/`,
    payload,
    token,
  );

  if (data) {
    yield put({
      type: types.DELETE_FORECAST_DATA_SUCCESS,
    });
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    successToast('Data was deleted successfully.');
  }
}

function* getClaimRowData(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/claim/${payload.claimId}/`,
    token,
  );

  if (data) {
    yield put({
      type: types.GET_CLAIM_ROW_DATA_SUCCESS,
      payload,
      res: data,
    });
  }
}

function* forecastWatcher() {
  yield takeLatest(types.GET_FORECAST_DATA_REQUEST, getForecastDataRequest);

  yield takeLatest(
    types.GET_FILTERED_FORECAST_DATA_REQUEST,
    getFilteredForecastData,
  );
  yield takeLatest(types.POST_FORECAST_DATA_REQUEST, postForecastData);
  yield takeLatest(types.GET_FORECAST_ROW_DATA_REQUEST, getForecastRowData);
  yield takeLatest(types.DELETE_FORECAST_DATA_REQUEST, deleteForecastData);
  // yield takeLatest(types.POST_CLAIM_DATA_REQUEST, postClaimData);
  yield takeLatest(types.GET_CLAIM_ROW_DATA_REQUEST, getClaimRowData);
}

export default forecastWatcher;
